import classNames from "classnames";

function Emoji4({ selected = false, onClick }) {
  return (
    <svg
      width="57"
      height="55"
      viewBox="0 0 57 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="cursor-pointer group"
      onClick={onClick}
    >
      <path
        d="M28.6222 48.0208C40.0116 48.0208 49.2445 38.8336 49.2445 27.5006C49.2445 16.1677 40.0116 6.98047 28.6222 6.98047C17.2329 6.98047 8 16.1677 8 27.5006C8 38.8336 17.2329 48.0208 28.6222 48.0208Z"
        className={classNames(
          "group-hover:fill-[#FFCC80]",
          selected ? "fill-[#FFCC80]" : "fill-[#E2E2E2]"
        )}
      />
      <g filter="url(#filter0_d_16442_1282)">
        <path
          d="M28.6222 48.0208C40.0116 48.0208 49.2445 38.8336 49.2445 27.5006C49.2445 16.1677 40.0116 6.98047 28.6222 6.98047C17.2329 6.98047 8 16.1677 8 27.5006C8 38.8336 17.2329 48.0208 28.6222 48.0208Z"
          stroke="white"
          strokeWidth="5"
          strokeMiterlimit="10"
          shapeRendering="crispEdges"
        />
      </g>
      <path
        d="M23.1371 26.3426C24.0906 26.3426 24.8635 24.9739 24.8635 23.2856C24.8635 21.5972 24.0906 20.2285 23.1371 20.2285C22.1836 20.2285 21.4106 21.5972 21.4106 23.2856C21.4106 24.9739 22.1836 26.3426 23.1371 26.3426Z"
        className={classNames(
          "group-hover:fill-[#1E1E1E]",
          selected ? "fill-[#1E1E1E]" : "fill-[#666666]"
        )}
      />
      <path
        d="M34.1073 26.3426C35.0608 26.3426 35.8338 24.9739 35.8338 23.2856C35.8338 21.5972 35.0608 20.2285 34.1073 20.2285C33.1538 20.2285 32.3809 21.5972 32.3809 23.2856C32.3809 24.9739 33.1538 26.3426 34.1073 26.3426Z"
        className={classNames(
          "group-hover:fill-[#1E1E1E]",
          selected ? "fill-[#1E1E1E]" : "fill-[#666666]"
        )}
      />
      <path
        d="M35.9493 31.2949C35.9493 33.6959 34.7802 35.8264 32.979 37.1588C31.7623 38.0516 30.2534 38.5859 28.6221 38.5859C26.9908 38.5859 25.4751 38.0516 24.2584 37.1588C22.4572 35.8264 21.2881 33.6959 21.2881 31.2949H35.9493Z"
        className={classNames(
          "group-hover:fill-[#1E1E1E]",
          selected ? "fill-[#1E1E1E]" : "fill-[#666666]"
        )}
      />
      <path
        opacity="0.77"
        d="M32.9789 37.1578C31.7622 38.0505 30.2533 38.5848 28.622 38.5848C26.9907 38.5848 25.475 38.0505 24.2583 37.1578C24.8564 35.3316 26.5829 34.0195 28.622 34.0195C30.6611 34.0195 32.3808 35.3316 32.9789 37.1578Z"
        className={classNames(
          "group-hover:fill-[#ED5F5F]",
          selected ? "fill-[#ED5F5F]" : "fill-[#E2E2E2]"
        )}
      />
      <defs>
        <filter
          id="filter0_d_16442_1282"
          x="1.5"
          y="0.480469"
          width="54.2446"
          height="54.041"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.650151 0 0 0 0 0.650151 0 0 0 0 0.650151 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_16442_1282"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_16442_1282"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default Emoji4;
